export default __webpack_public_path__ + "static/media/weighing-scale.ca8073e4.svg";